import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// COMPONENTES
import { DashboardComponent } from './dashboard/dashboard.component';
import { RouterModule } from '@angular/router';
import { ErrorComponent } from './error/error.component';



@NgModule({
  declarations: [
    DashboardComponent,
    ErrorComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class InicioModule { }
